"use strict";

var regexValidator = require('./regexValidator');
var _require = require('./errors'),
  InvalidPageError = _require.InvalidPageError;
var pageRegex = /^[a-zA-Z0-9._-]+$/;
var validator = regexValidator(pageRegex, InvalidPageError);
module.exports = function () {
  return {
    validate: function validate(page) {
      return validator.validate(page);
    }
  };
};
//# sourceMappingURL=pageValidtor.js.map